import React from 'react';
import ReactQuill, { Quill } from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import './CustomQuillEditor.scss';

import { QUILL_FORMATS, QUILL_MODULES } from './constant/CustomQuillEditor.constant';
import { CustomEditorProps } from './types/CustomQuillEditor.types';
import { useCustomQuillEditor } from './hooks/useCustomQuillEditor';

// Importar el attributor de alineación basado en estilos e indicar a Quill que lo use
const AlignStyle = Quill.import('attributors/style/align');
Quill.register(AlignStyle as any, true);

const CustomQuillEditor: React.FC<CustomEditorProps> = ({ 
  value, 
  onChange, 
  placeholder = 'Compártenos tu experiencia y tu sentir...',
  variant = 'default'
}) => {
    
  const { 
    quillRef,
    localValue, 
    cleanPlaceholder, 
    handleChange 
  } = useCustomQuillEditor({ value, onChange, placeholder });

  return (
    <div className={`quill-editor-wrapper quill-editor-wrapper--${variant}`}>
      <ReactQuill 
        ref={quillRef}
        theme="snow"
        value={localValue}
        onChange={handleChange}
        modules={QUILL_MODULES}
        formats={QUILL_FORMATS}
        placeholder={cleanPlaceholder}
      />
    </div>
  );
};

export default CustomQuillEditor;